import { rem } from 'polished'
import styled from 'styled-components'

import { CollapsibleContentStyled } from './CollapsibleContentStyled'

interface ICollapsibleStyledProps {
  iconPosition?: 'left' | 'right'
}

export const CollapsibleStyled = styled.div<ICollapsibleStyledProps>`
  font-size: ${rem(16)};
  width: 100%;

  .title,
  .content {
    width: 100%;
  }

  .title {
    font-weight: ${(props) => props.theme.fontWeights.semibold};
    cursor: pointer;
    position: relative;

    .icon-wrapper {
      display: block;
      text-align: center;
      width: ${(props) => props.theme.typography.pxToRem(48)};
    }
  }

  ${CollapsibleContentStyled} {
    padding-top: ${(props) => props.theme.space.medium};
    padding-bottom: ${(props) => props.theme.space.medium};
    padding-left: ${(props) =>
      props.iconPosition === 'right'
        ? '0'
        : props.theme.typography.pxToRem(48)};
    padding-right: ${(props) =>
      props.iconPosition === 'right' ? '0' : props.theme.space.medium};
  }
`
